import React, { useState } from "react";
import { useContentGeneration } from "../../hooks/useContentGeneration";
import { useAuthContext } from "../../hooks/useAuthContext";
// import flashFormElements from "../../Components/Flash-Form-Object";
import { useParams } from "react-router-dom";
import { useContentsContext } from "../../hooks/useContentsContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import validator from "validator";
// import FormElements from "../../Components/TestFormObject"
import FormElements from "../../Components/Forms";
import languages from "./languages";
function CreateForm(props) {
    var CustomTag = "";
    const { dispatchcontent } = useContentsContext()
    const params = useParams();
    const { user } = useAuthContext()
    const [isDisabled, setIsDisabled] = useState("");
    const [boolVal, isboolVal] = useState();
    const { sendContentGenerationRequest, fetchSpecificHistory } = useContentGeneration();
    const [state, setState] = useState({});
    const[documentName,setDocumentName] = useState();
    const onChange = (e) => {
        const { name, value } = e.target;


        setState({
            ...state,
            documentName:documentName,
            "flash": validator.escape(params.flashName),
            [name]: value
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault()
        //generate the content and s
        setIsDisabled(true)
        isboolVal(true)
        props.onSubmit(boolVal)
        const content = await sendContentGenerationRequest(state)
        //send it to the page via props
      
        if (content.status === 400) {
     
           const json = await content.json()
         
             props.onSubmit(boolVal,json.error)
             setIsDisabled(false)
        } else {
            const json = await content.json()
            props.onSubmit(boolVal, json)
            setIsDisabled(false)
            //fetch the generated data from the db

            const data = await fetchSpecificHistory(params.flashName)
            dispatchcontent({ type: 'FETCH_CONTENTS', payload: data })


        }





    }



    if (user) {
        return (
            <div>
                {

                    FormElements.filter(data => data.flashname === params.flashName).map((values) => {
                        return (
                            <div className="form-row font-Rajdhani">

                                <form onSubmit={handleSubmit} >
                                <label  className="font-medium py-2 text-xl">
   Name
</label>
<input type="text" name="documentName" onChange={(e) => setDocumentName(e.target.value)} required placeholder="Give this response a name this will help you find it in the history page" className="dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-medium rounded shadow-sm w-full font-Rajdhani  text-gray-900 outline-none px-3 py-1 focus:outline-none"/><br/>

                                    {(values.inputs).map((t) => {

                                        CustomTag = t['type']

                                        return (
                                            <div className="col font-Rajdhani">

                                                <label className="font-medium py-2 text-xl">{t['label']}</label>
                                                <CustomTag className="dark:bg-[#2c2f44]  dark:text-[#99a0ac] border font-medium rounded shadow-sm w-full font-Rajdhani  text-gray-900 outline-none px-3 py-1 focus:outline-none"   name={t['name']} placeholder={t['placeholder']} required onChange={onChange} />

                                                {/* <CustomTag className="form-control bg-white px-3 py-1 dark:bg-[#2e3247]" name={t['name']} placeholder={t['placeholder']} required onChange={onChange} /> */}
                                                {/* {t['type']}  className="form-control bg-white px-3 py-1" name={values.flashname} required onChange={onChange} /> */}
                                            </div>
                                        )
                                    })}

<div className="flex justify-end">
<div className="flex  items-center">
<p className=" mt-3 font-medium mr-2 ">Outputs</p>
<select name="output"  className="border w-[50px]   mr-2 rounded font-medium p-2 dark:bg-[#818998] dark:text-white dark:bg-none" onChange={onChange} >
{[1, 2, 3, 4].map(num => (
                            <option key={num} value={num}>{num}</option>
                        ))}
           
                                    </select>
   </div>
                                  <div className="flex  items-center">
                                  <p className=" mt-3 font-medium mr-2">Language</p>
                                    <select name="language"  className="border  mr-2 rounded font-medium p-2 dark:bg-[#818998] dark:text-white dark:bg-none" onChange={onChange} >
                                    {languages.map((lang)=>(
                                       <option value={lang}>{lang}</option>
                                    ))}
                                     
                                    </select>
                                    </div>
                                    <div>

                                 
                                        <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600 mt-2" disabled={isDisabled} >Generate
                                        </button>
                                        </div>
                                    </div>
                                </form>
                                <div className="flex justify-end font-normal">

                                </div>
                            </div>


                        )
                    })

                }
                {/* {flashFormElements.filter(data => data.url === "/" + params.flashName).map((values) => {

                    return (

                        <div className="form-row">

                            <form onSubmit={handleSubmit} >
                                {Object.entries(values.inputBox.label).map((t) => (
                                    <div className="col">
                                        <label className="font-medium py-2">{t[1]}</label>
                                        <input className="form-control bg-white px-3 py-1" name={t[0]} required onChange={onChange} />
                                    </div>
                                ))}

                                <div className="col ">
                                    <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600   mt-2" disabled={isDisabled} >Generate  
                                    </button>
                 
                                </div>
                            </form>
                         
                        </div>
                    )
                })} */}
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>

        )

    }
}
export default CreateForm;